import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import SelfStatsAffectedSkin from "../Components/SelfStatsAffectedSkin";
import SelfStatsSkinMood from "../Components/SelfStatsSkinMood";
import SelfStatsFlareUp from "../Components/SelfStatsFlareUp";
import EmotionalLevelGraph from "../Components/EmotionalLevelGraph";
import "./Theme.css";
import "./SelfStats.css";
import "../Components/SelfStats.css";

const SelfStatsPfizer = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const goqiiUserId = getGoqiiUserId();
  const action = urlParams.get("action") || "";

  const [apiResponse, setApiResponse] = useState([]);
  const [flareUpStats, setFlareUpStats] = useState([]);
  const [skinStats, setSkinStats] = useState([]);
  const [score, setScore] = useState("");
  const [selectedStates, setSelectedStates] = useState([]);
  const [logDate, setLogDate] = useState("");
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    return new Date(d.getTime() - 6 * 24 * 60 * 60 * 1000);
  });
  const [endDate, setEndDate] = useState(new Date());

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  const loadStats = () => {
    lifestyleApi.fetchEmotionalGraph({ goqiiUserId })
      .then((res) => { if (res.data.data?.moodLogResponse) setApiResponse(res.data.data.moodLogResponse); })
      .catch((err) => console.error("fetchEmotionalGraph:", err));

    lifestyleApi.fetchSkinMood()
      .then((res) => setSkinStats(res.data.data?.response || []))
      .catch((err) => console.error("fetchSkinMood:", err));

    lifestyleApi.fetchFlareUpStats()
      .then((res) => setFlareUpStats((res.data.scoreResponse || []).reverse()))
      .catch((err) => console.error("fetchFlareUpStats:", err));

    lifestyleApi.fetchBsaDetails()
      .then((res) => setSelectedStates(res.data.data || []))
      .catch((err) => console.error("fetchBsaDetails:", err));

    lifestyleApi.fetchBsaScore()
      .then((res) => {
        setScore(res.data.data?.score || "");
        setLogDate(res.data.data?.logDate || "");
      })
      .catch((err) => console.error("fetchBsaScore:", err));
  };

  useEffect(() => {
    loadStats();

    // Mobile browsers/webviews often restore this page from bfcache when the
    // user navigates back (e.g. after logging a new BSA%), which skips this
    // effect entirely and leaves stale stats on screen. Re-fetch whenever the
    // page is restored that way.
    const onPageShow = (event) => {
      if (event.persisted) loadStats();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  const shiftDates = (delta) => {
    const today = new Date();
    const ns = new Date(startDate.getTime() + delta);
    const ne = new Date(endDate.getTime() + delta);
    if (delta > 0) {
      setStartDate(ne > today ? startDate : ns);
      setEndDate(ne > today ? today : ne);
    } else {
      setStartDate(ns);
      setEndDate(ne);
    }
  };

  return (
    <>
      <section className="ss-page">
        <div className="ss-date-nav">
          <button className="ss-arrow-btn" onClick={() => shiftDates(-7 * 86400000)}>&#8249;</button>
          <span className="ss-date-range">
            {startDate.toLocaleDateString("en-GB", { day: "numeric", month: "short" })} to{" "}
            {endDate.toLocaleDateString("en-GB", { day: "numeric", month: "short" })}
          </span>
          {endDate.toDateString() !== new Date().toDateString() && (
            <button className="ss-arrow-btn" onClick={() => shiftDates(7 * 86400000)}>&#8250;</button>
          )}
        </div>

        {action === "Y" && (
          <SelfStatsAffectedSkin selectedStates={selectedStates} score={score} logDate={logDate} />
        )}

        <SelfStatsSkinMood skinStats={skinStats} startDate={startDate} endDate={endDate} />
        <SelfStatsFlareUp flareUpStats={flareUpStats} startDate={startDate} endDate={endDate} />

        <div className="selfstats-box">
          <h2 className="selfstats-title">{t("selfStats.emotionalTrend")}</h2>
          <ul className="selfstats-legend">
            <li><span className="dot" style={{ background: "#4cd964" }}></span> {t("selfStats.excellent")}</li>
            <li><span className="dot" style={{ background: "#5ac8fa" }}></span> {t("selfStats.good")}</li>
            <li><span className="dot" style={{ background: "#ffcc00" }}></span> {t("selfStats.okay")}</li>
            <li><span className="dot" style={{ background: "#ff9500" }}></span> {t("selfStats.sad")}</li>
            <li><span className="dot" style={{ background: "#ff3b30" }}></span> {t("selfStats.terrible")}</li>
          </ul>
          <EmotionalLevelGraph apiResponses={apiResponse} startDate={startDate} endDate={endDate} />
        </div>
      </section>
    </>
  );
};

export default SelfStatsPfizer;
